import React from 'react'

export default function Logo({src, className}) {
  return (
    <div className={className ?? ''}>
        <img src={src} className="img" alt="Logo" />
    </div>
  )
}
